import { ReactNode } from 'react';

import { useMediaQuery } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

import { Constants, MEDIA_QUERIES } from '@arrived/common';

interface PrivacyTermsWrapperProps {
  className?: string;
  children?: ReactNode;
}

const StyledPrivacyTermsWrapper = styled.div`
  &.privacy-terms-wrapper {
    margin-top: ${(props) => props.theme.spacing(2)};
    padding: ${(props) => props.theme.spacing(0, 4, 4)};

    h4 {
      margin-top: ${(props) => props.theme.spacing(4)};
    }

    h5,
    p,
    div {
      margin-top: ${(props) => props.theme.spacing(2)};
    }

    ul,
    ol {
      li {
        margin-bottom: ${(props) => props.theme.spacing(2)};

        .title {
          margin-bottom: ${(props) => props.theme.spacing(2)};
        }
      }
    }

    a,
    a:visited {
      color: ${({ theme }) => theme.palette.primary.main};
      text-decoration: underline;
    }

    &.print {
      margin-top: 0;
    }
  }
`;

export const PrivacyTermsWrapper = ({ children, className }: PrivacyTermsWrapperProps) => {
  const isPrint = useMediaQuery(MEDIA_QUERIES.isPrint);

  return (
    <StyledPrivacyTermsWrapper className={clsx('privacy-terms-wrapper', className, isPrint && 'print')}>
      {children}
    </StyledPrivacyTermsWrapper>
  );
};
